"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoolioControlModeValidation = void 0;
class CoolioControlModeValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 3)) {
            return false;
        }
        return true;
    }
}
exports.CoolioControlModeValidation = CoolioControlModeValidation;
